import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable, map } from 'rxjs'

import { ApiHttpService } from '@flowx/designer/shared/api/api-http.service'

export type WarningsMessageRequest = {
  application_id: string
  application_version: string
  process_id: string
  category: string
}

export type CheckProcessRequest = {
  application_id: string
  application_version: string
  process_id: string
  session_id: string
}

export type InspectProcessPayload = {
  application_id: string
  application_version: string
  process_id: string
  process: any
  datamodel?: any[]
  ui_elements?: any
  navigation?: any
  available_processes?: any[]
  session_id?: string
}

export type UpdateWarningStatusRequest = {
  warning_id: string
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'RESOLVED'
}

export enum WarningCategory {
  PROCESS = 'PROCESS',
  ALL = '',
}

@Injectable({ providedIn: 'root' })
export class AiInspectorApi extends ApiHttpService {
  #inspectorV1 = 'ai-engine/api/v1/inspector'

  constructor() {
    super(inject<string>('BASE_URL' as any), inject(HttpClient))
  }

  getWarningsMessages(payload: WarningsMessageRequest): Observable<any> {
    return this.get(
      `${this.#inspectorV1}/warnings/all?application_id=${payload.application_id}&application_version=${payload.application_version}&process_id=${payload.process_id}&category=${payload.category}`
    )
  }

  getWarningsCount(payload: WarningsMessageRequest): Observable<any> {
    return this.get(
      `${this.#inspectorV1}/warnings/count?application_id=${payload.application_id}&application_version=${payload.application_version}&process_id=${payload.process_id}&category=${payload.category}`
    )
  }

  getRules(category: WarningCategory): Observable<any> {
    return this.get(`${this.#inspectorV1}/rules/all?category=${category}`)
  }

  checkProcess(payload: CheckProcessRequest): Observable<any> {
    return this.post(`${this.#inspectorV1}/process`, payload)
  }

  updateWarningStatus(payload: UpdateWarningStatusRequest): Observable<any> {
    return this.post(`${this.#inspectorV1}/warnings/status/update`, payload)
  }

  inspectProcess(payload: InspectProcessPayload): Observable<any> {
    return this.streamArray('ai-engine/agents/inspector/inspect', payload).pipe(
      map((response: any) => response || null),
      map((answerStr) => ({ message: answerStr }))
    )
  }
}
